import styles from "./index.module.css";
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

/**
 * Displays a Diamond icon with the background color depending on the pinLevel ( 1-4 (diamond, emerald, platinum and associate) )
 */

export default function PinIcon({ pinLevel }) {
  return (
    <div className={styles.container}>
      <svg
        className={classNames({
          [styles.diamond]: pinLevel === 4,
          [styles.emerald]: pinLevel === 3,
          [styles.platinum]: pinLevel === 2,
          [styles.associate]: pinLevel === 1,
          [styles.unknown]: [1, 2, 3, 4].includes(pinLevel) === false,
        })}
        // transform="rotate(22.5)" // for making the rotation match the WWG logo
        viewBox="0 0 321 294"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="icon"
          transform="translate(160.500000, 147.000000) rotate(-22.500000) translate(-160.500000, -147.000000) translate(31.000000, 42.000000)"
          fillRule="nonzero"
        >
          <polygon
            id="Path"
            points="63.274 0.4017 3.213 21.1864 74.841 50.789 111.707 13.1213"
          ></polygon>
          <polygon
            id="Path"
            points="117.771 15.6274 81.663 53.609 177.546 93.236 180.682 41.628"
          ></polygon>
          <polygon
            id="Path"
            points="184.746 96.212 186.746 44.134 230.406 69.476 258.648 126.755"
          ></polygon>
          <polygon
            id="Path"
            points="66.984 200.783 0.315 28.1981 71.943 57.801"
          ></polygon>
          <polygon
            id="Path"
            points="174.648 100.248 78.765 60.621 73.987 209.606"
          ></polygon>
          <polygon
            id="Path"
            points="84.038 207.831 181.849 103.224 255.751 133.767"
          ></polygon>
        </g>
      </svg>
    </div>
  );
}

PinIcon.propTypes = {
  /**
   * Determines the style of the diamond ( 1-4 (diamond, emerald, platinum and associate) )
   */
  pinLevel: PropTypes.number,
};
